import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day 4+5, it just takes determination",
  "description": "",
  "published": "2009-11-05T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day-45-it-just-takes-determination/swizec/807"],
  "categories": "Psychology, Recreation, Steampunk, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I actually fulfilled the daily nanowrimo quota! That's right my little poison berries, I wrote 1568 words! Well alright, that's a hundred words short but hey, more than ever!`}</p>
    <p>{`In today's passage you might notice a certain Professor Foglio, I feel like I should mention this is a nod to one of my favouritest steampunk webcomics. I'd tell you which, but that's just silly, literary references are for careful readers who then appreciate them properly.`}</p>
    <p>{`However, interesting tid bit, professor Von Tropp - noticed all over the place in what I'm writing and actually a somewhat important character to the loose storyline I'm aiming for - happens to be my pseudonym used in the ... I'd say few, but it's just one ... thing I wrote for Steampunk Magazine.`}</p>
    <p>{`Ze today's writing:`}</p>
    <blockquote>
      <p parentName="blockquote">{`The bats let out a little squeak when Moe gave them the water. Who`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      